import { render, staticRenderFns } from "./TrainingRequestConfiguration.vue?vue&type=template&id=6cf946f1&"
import script from "./TrainingRequestConfiguration.vue?vue&type=script&lang=js&"
export * from "./TrainingRequestConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports